/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type SearchInvoicesQueryVariables = Types.Exact<{
  search?: Types.InputMaybe<Types.InvoiceSearch>;
  pagination: Types.Pagination;
}>;


export type SearchInvoicesQuery = {
  __typename?: 'Query',
  searchInvoices: {
    __typename?: 'InvoicePage',
    totalElements: number,
    content: Array<{
      __typename?: 'Invoice',
      id: number,
      invoiceNumber?: string | null,
      yourReference?: string | null,
      date?: number | null,
      totalAmount?: number | null,
      lastStatusChange?: {
        __typename?: 'StatusChange',
        id: number,
        actualTime?: number | null,
        actualTimeOriginal?: number | null,
        actualTimeOverride?: number | null,
        estimateTime?: number | null,
        comment?: string | null,
        skipperComment?: string | null,
        timestamp?: number | null,
        appliedBy?: string | null,
        deletable: boolean,
        communicatedToCustomer?: number | null,
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }>,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null
        },
        supplier?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        origin?: {
          __typename?: 'StatusChange',
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }
        } | null
      } | null,
      statusChanges: Array<{
        __typename?: 'StatusChange',
        id: number,
        actualTime?: number | null,
        actualTimeOriginal?: number | null,
        actualTimeOverride?: number | null,
        estimateTime?: number | null,
        comment?: string | null,
        skipperComment?: string | null,
        timestamp?: number | null,
        appliedBy?: string | null,
        deletable: boolean,
        communicatedToCustomer?: number | null,
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }>,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null
        },
        supplier?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        origin?: {
          __typename?: 'StatusChange',
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }
        } | null
      }>,
      creditor?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      debtor?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      currency?: {
        __typename?: 'Currency',
        isoCode?: string | null,
        symbol?: string | null
      } | null,
      paymentTerm?: {
        __typename?: 'PaymentTerm',
        id: number,
        externalReference?: string | null,
        days: number
      } | null
    }>
  }
};

export type GetInvoiceQueryVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type GetInvoiceQuery = {
  __typename?: 'Query',
  invoice?: {
    __typename?: 'Invoice',
    totalExcVAT?: number | null,
    totalVAT?: number | null,
    id: number,
    invoiceNumber?: string | null,
    yourReference?: string | null,
    date?: number | null,
    totalAmount?: number | null,
    lines: Array<{
      __typename?: 'InvoiceLine',
      id: number,
      approved?: boolean | null,
      quantity?: number | null,
      totalPriceExcVAT?: number | null,
      totalPriceIncVAT?: number | null,
      unit?: string | null,
      invoiceReference?: string | null,
      description?: string | null,
      unexpected?: boolean | null,
      summary?: string | null,
      calculationSummary?: string | null,
      declaration?: {
        __typename?: 'PurchaseDeclaration',
        id: number,
        closedOn?: number | null,
        financiallyReadiedOn?: number | null,
        invoiceGroupType?: {
          __typename?: 'InvoiceGroupType',
          id: number,
          name: string
        } | null,
        charter?: {
          __typename?: 'PurchaseCharter',
          type: Types.CharterType,
          id: number,
          charterNumber: string
        } | {
          __typename?: 'SalesCharter',
          blDate?: number | null,
          type: Types.CharterType,
          id: number,
          charterNumber: string,
          status: {
            __typename?: 'SalesCharterStatusType',
            name: Types.SalesCharterStatus,
            color: string,
            languageKeyPrefix: string
          }
        } | null,
        lastStatusChange?: {
          __typename?: 'StatusChange',
          id: number,
          actualTime?: number | null,
          actualTimeOriginal?: number | null,
          actualTimeOverride?: number | null,
          estimateTime?: number | null,
          comment?: string | null,
          skipperComment?: string | null,
          timestamp?: number | null,
          appliedBy?: string | null,
          deletable: boolean,
          communicatedToCustomer?: number | null,
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }>,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null
          },
          supplier?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          origin?: {
            __typename?: 'StatusChange',
            status: {
              __typename?: 'Status',
              id: number,
              description: string,
              type: Types.StatusType,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }
          } | null
        } | null,
        statusChanges: Array<{
          __typename?: 'StatusChange',
          id: number,
          actualTime?: number | null,
          actualTimeOriginal?: number | null,
          actualTimeOverride?: number | null,
          estimateTime?: number | null,
          comment?: string | null,
          skipperComment?: string | null,
          timestamp?: number | null,
          appliedBy?: string | null,
          deletable: boolean,
          communicatedToCustomer?: number | null,
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }>,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null
          },
          supplier?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          origin?: {
            __typename?: 'StatusChange',
            status: {
              __typename?: 'Status',
              id: number,
              description: string,
              type: Types.StatusType,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }
          } | null
        }>
      } | {
        __typename?: 'SalesDeclaration',
        id: number,
        closedOn?: number | null,
        financiallyReadiedOn?: number | null,
        invoiceGroupType?: {
          __typename?: 'InvoiceGroupType',
          id: number,
          name: string
        } | null,
        charter?: {
          __typename?: 'PurchaseCharter',
          type: Types.CharterType,
          id: number,
          charterNumber: string
        } | {
          __typename?: 'SalesCharter',
          blDate?: number | null,
          type: Types.CharterType,
          id: number,
          charterNumber: string,
          status: {
            __typename?: 'SalesCharterStatusType',
            name: Types.SalesCharterStatus,
            color: string,
            languageKeyPrefix: string
          }
        } | null,
        lastStatusChange?: {
          __typename?: 'StatusChange',
          id: number,
          actualTime?: number | null,
          actualTimeOriginal?: number | null,
          actualTimeOverride?: number | null,
          estimateTime?: number | null,
          comment?: string | null,
          skipperComment?: string | null,
          timestamp?: number | null,
          appliedBy?: string | null,
          deletable: boolean,
          communicatedToCustomer?: number | null,
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }>,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null
          },
          supplier?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          origin?: {
            __typename?: 'StatusChange',
            status: {
              __typename?: 'Status',
              id: number,
              description: string,
              type: Types.StatusType,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }
          } | null
        } | null,
        statusChanges: Array<{
          __typename?: 'StatusChange',
          id: number,
          actualTime?: number | null,
          actualTimeOriginal?: number | null,
          actualTimeOverride?: number | null,
          estimateTime?: number | null,
          comment?: string | null,
          skipperComment?: string | null,
          timestamp?: number | null,
          appliedBy?: string | null,
          deletable: boolean,
          communicatedToCustomer?: number | null,
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }>,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null
          },
          supplier?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          origin?: {
            __typename?: 'StatusChange',
            status: {
              __typename?: 'Status',
              id: number,
              description: string,
              type: Types.StatusType,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }
          } | null
        }>
      } | null,
      costType?: {
        __typename?: 'CostType',
        id: number,
        title_en?: string | null,
        title_de?: string | null,
        title_nl?: string | null
      } | null,
      price?: {
        __typename?: 'Price',
        value?: number | null,
        currency?: {
          __typename?: 'Currency',
          isoCode?: string | null,
          symbol?: string | null
        } | null
      } | null,
      debtor?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      creditor?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      agreement?: {
        __typename?: 'AddressCommissionAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'BlockFreightAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'BunkerAdjustmentAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'CleaningAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'CommissionAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'DailyAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'DangerousGoodAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'DeadfreightAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'DemurrageAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'DemurrageCalculationAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'FeetAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'FreightAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'GasolineAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'GasolinePriceAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'HoseRentalAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'HourlyAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'LumpsumAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'MultiCargoAdjustmentAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'MultiOrderAdjustmentAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'NitrogenPurgingAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'OogAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'PJKAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'PostCalculationAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'ReeferAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'RentAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'ReturnFreightDiscountAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'ShipAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'SupplementaryHeatingAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'TeuAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'TextAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'WaterLevelAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'WaterwayAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'WeightAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'WeightRangeAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        summary?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | null,
      vatCode?: {
        __typename?: 'VATCode',
        id: number,
        label?: string | null,
        percentage: number
      } | null
    }>,
    lastStatusChange?: {
      __typename?: 'StatusChange',
      id: number,
      actualTime?: number | null,
      actualTimeOriginal?: number | null,
      actualTimeOverride?: number | null,
      estimateTime?: number | null,
      comment?: string | null,
      skipperComment?: string | null,
      timestamp?: number | null,
      appliedBy?: string | null,
      deletable: boolean,
      communicatedToCustomer?: number | null,
      status: {
        __typename?: 'Status',
        id: number,
        description: string,
        type: Types.StatusType,
        cargoActionType?: Types.CallType | null,
        color: string,
        statusOrder?: number | null,
        supplierRequired: boolean,
        skipperRequiredFillInSailingReport: boolean,
        skipperRequiredFillInWeightVolume: boolean,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean,
        requireActualTime: Types.StatusActualTimeType,
        estimateType?: Types.StatusEstimateType | null,
        estimateRequirement: Types.StatusEstimateRequirement,
        shouldLoadOnTerminal: boolean,
        closedStatus: boolean,
        cancelledStatus: boolean,
        loadedStatus: boolean,
        dischargedStatus: boolean,
        finishedStatus: boolean,
        allowComment: boolean,
        allowSkipperComment: boolean,
        shouldUpdateJDE: boolean,
        isInProgress: boolean,
        voyageVisibleBySkipper: boolean,
        voyageVisibleByCreditor: boolean,
        voyageEditableBySkipper: boolean,
        voyageEditableByCreditor: boolean,
        callVisibleByLocationOwner: boolean,
        isRejectStatus: boolean,
        isAcceptStatus: boolean,
        notifySkippers: boolean,
        notifyShipManagers: boolean,
        notifyShipOwners: boolean,
        notifyOperators: boolean,
        notifyCustomers: boolean,
        notifyTerminals: boolean,
        isCustomerNominatingStatus: boolean,
        isSkipperNominatingStatus: boolean,
        includeInNominationExport: boolean,
        laytimeStartStatus: boolean,
        laytimeEndStatus: boolean,
        requireDocuments: boolean,
        showConfirmMessage: boolean,
        expiringStatus: boolean,
        isActionStatus: boolean,
        requireTanks: boolean,
        successiveStatuses: Array<{
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          description: string,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }>,
        sendDocument?: {
          __typename?: 'SendDocumentStatus',
          enabled: boolean,
          type?: Types.SendDocumentType | null,
          target?: Types.DocumentTarget | null
        } | null,
        translations?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        confirmMessages?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        rules?: Array<{
          __typename?: 'Rule',
          id: number,
          ifFitsStatusFlow: boolean,
          ifNotAppliedBefore: boolean,
          ruleType: {
            __typename?: 'RuleType',
            name: Types.StatusRule
          },
          targetStatus: {
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            supplierRequired: boolean,
            description: string,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean
            } | null
          }
        }> | null
      },
      supplier?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      origin?: {
        __typename?: 'StatusChange',
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }
      } | null
    } | null,
    statusChanges: Array<{
      __typename?: 'StatusChange',
      id: number,
      actualTime?: number | null,
      actualTimeOriginal?: number | null,
      actualTimeOverride?: number | null,
      estimateTime?: number | null,
      comment?: string | null,
      skipperComment?: string | null,
      timestamp?: number | null,
      appliedBy?: string | null,
      deletable: boolean,
      communicatedToCustomer?: number | null,
      status: {
        __typename?: 'Status',
        id: number,
        description: string,
        type: Types.StatusType,
        cargoActionType?: Types.CallType | null,
        color: string,
        statusOrder?: number | null,
        supplierRequired: boolean,
        skipperRequiredFillInSailingReport: boolean,
        skipperRequiredFillInWeightVolume: boolean,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean,
        requireActualTime: Types.StatusActualTimeType,
        estimateType?: Types.StatusEstimateType | null,
        estimateRequirement: Types.StatusEstimateRequirement,
        shouldLoadOnTerminal: boolean,
        closedStatus: boolean,
        cancelledStatus: boolean,
        loadedStatus: boolean,
        dischargedStatus: boolean,
        finishedStatus: boolean,
        allowComment: boolean,
        allowSkipperComment: boolean,
        shouldUpdateJDE: boolean,
        isInProgress: boolean,
        voyageVisibleBySkipper: boolean,
        voyageVisibleByCreditor: boolean,
        voyageEditableBySkipper: boolean,
        voyageEditableByCreditor: boolean,
        callVisibleByLocationOwner: boolean,
        isRejectStatus: boolean,
        isAcceptStatus: boolean,
        notifySkippers: boolean,
        notifyShipManagers: boolean,
        notifyShipOwners: boolean,
        notifyOperators: boolean,
        notifyCustomers: boolean,
        notifyTerminals: boolean,
        isCustomerNominatingStatus: boolean,
        isSkipperNominatingStatus: boolean,
        includeInNominationExport: boolean,
        laytimeStartStatus: boolean,
        laytimeEndStatus: boolean,
        requireDocuments: boolean,
        showConfirmMessage: boolean,
        expiringStatus: boolean,
        isActionStatus: boolean,
        requireTanks: boolean,
        successiveStatuses: Array<{
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          description: string,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }>,
        sendDocument?: {
          __typename?: 'SendDocumentStatus',
          enabled: boolean,
          type?: Types.SendDocumentType | null,
          target?: Types.DocumentTarget | null
        } | null,
        translations?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        confirmMessages?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        rules?: Array<{
          __typename?: 'Rule',
          id: number,
          ifFitsStatusFlow: boolean,
          ifNotAppliedBefore: boolean,
          ruleType: {
            __typename?: 'RuleType',
            name: Types.StatusRule
          },
          targetStatus: {
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            supplierRequired: boolean,
            description: string,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean
            } | null
          }
        }> | null
      },
      supplier?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      origin?: {
        __typename?: 'StatusChange',
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }
      } | null
    }>,
    creditor?: {
      __typename?: 'Relation',
      id: number,
      name: string
    } | null,
    debtor?: {
      __typename?: 'Relation',
      id: number,
      name: string
    } | null,
    currency?: {
      __typename?: 'Currency',
      isoCode?: string | null,
      symbol?: string | null
    } | null,
    paymentTerm?: {
      __typename?: 'PaymentTerm',
      id: number,
      externalReference?: string | null,
      days: number
    } | null
  } | null
};

export type SearchDeclarationsForInvoicingQueryVariables = Types.Exact<{
  search?: Types.InputMaybe<Types.DeclarationSearch>;
  pagination: Types.Pagination;
}>;


export type SearchDeclarationsForInvoicingQuery = {
  __typename?: 'Query',
  searchDeclarations: {
    __typename?: 'DeclarationPage',
    totalElements: number,
    content: Array<{
      __typename?: 'PurchaseDeclaration',
      id: number,
      closedOn?: number | null,
      financiallyReadiedOn?: number | null,
      totalPriceExcVAT?: number | null,
      window?: {
        __typename?: 'TimeWindow',
        from?: number | null,
        to?: number | null
      } | null,
      lastStatusChange?: {
        __typename?: 'StatusChange',
        id: number,
        actualTime?: number | null,
        actualTimeOriginal?: number | null,
        actualTimeOverride?: number | null,
        estimateTime?: number | null,
        comment?: string | null,
        skipperComment?: string | null,
        timestamp?: number | null,
        appliedBy?: string | null,
        deletable: boolean,
        communicatedToCustomer?: number | null,
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }>,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null
        },
        supplier?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        origin?: {
          __typename?: 'StatusChange',
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }
        } | null
      } | null,
      statusChanges: Array<{
        __typename?: 'StatusChange',
        id: number,
        actualTime?: number | null,
        actualTimeOriginal?: number | null,
        actualTimeOverride?: number | null,
        estimateTime?: number | null,
        comment?: string | null,
        skipperComment?: string | null,
        timestamp?: number | null,
        appliedBy?: string | null,
        deletable: boolean,
        communicatedToCustomer?: number | null,
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }>,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null
        },
        supplier?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        origin?: {
          __typename?: 'StatusChange',
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }
        } | null
      }>,
      invoiceGroupType?: {
        __typename?: 'InvoiceGroupType',
        id: number,
        name: string
      } | null,
      charter?: {
        __typename?: 'PurchaseCharter',
        blDate?: number | null,
        id: number,
        charterNumber: string,
        type: Types.CharterType,
        customerReference?: string | null,
        subtype: Types.CharterSubtype,
        voyages?: Array<{
          __typename?: 'Voyage',
          ship: {
            __typename?: 'Ship',
            id: number,
            name: string
          },
          cargoCharters?: Array<{
            __typename?: 'SalesCharter',
            id: number,
            charterNumber: string,
            type: Types.CharterType,
            subtype: Types.CharterSubtype,
            customerReference?: string | null,
            dossierNumber?: string | null
          } | null> | null
        }> | null,
        contract?: {
          __typename?: 'Contract',
          currency?: {
            __typename?: 'Currency',
            symbol?: string | null,
            isoCode?: string | null
          } | null
        } | null
      } | {
        __typename?: 'SalesCharter',
        blDate?: number | null,
        dossierNumber?: string | null,
        customerReference?: string | null,
        id: number,
        charterNumber: string,
        type: Types.CharterType,
        subtype: Types.CharterSubtype,
        status: {
          __typename?: 'SalesCharterStatusType',
          name: Types.SalesCharterStatus,
          color: string,
          languageKeyPrefix: string
        },
        purchaseCharter?: {
          __typename?: 'PurchaseCharter',
          charterNumber: string,
          type: Types.CharterType,
          subtype: Types.CharterSubtype,
          voyages?: Array<{
            __typename?: 'Voyage',
            ship: {
              __typename?: 'Ship',
              id: number,
              name: string
            }
          }> | null
        } | null,
        contract?: {
          __typename?: 'Contract',
          currency?: {
            __typename?: 'Currency',
            symbol?: string | null,
            isoCode?: string | null
          } | null
        } | null
      } | null,
      invoiceLines: Array<{
        __typename?: 'InvoiceLine',
        id: number,
        approved?: boolean | null,
        invoice?: {
          __typename?: 'Invoice',
          id: number,
          invoiceNumber?: string | null
        } | null,
        creditor?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        debtor?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null
      }>
    } | {
      __typename?: 'SalesDeclaration',
      id: number,
      closedOn?: number | null,
      financiallyReadiedOn?: number | null,
      totalPriceExcVAT?: number | null,
      window?: {
        __typename?: 'TimeWindow',
        from?: number | null,
        to?: number | null
      } | null,
      lastStatusChange?: {
        __typename?: 'StatusChange',
        id: number,
        actualTime?: number | null,
        actualTimeOriginal?: number | null,
        actualTimeOverride?: number | null,
        estimateTime?: number | null,
        comment?: string | null,
        skipperComment?: string | null,
        timestamp?: number | null,
        appliedBy?: string | null,
        deletable: boolean,
        communicatedToCustomer?: number | null,
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }>,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null
        },
        supplier?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        origin?: {
          __typename?: 'StatusChange',
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }
        } | null
      } | null,
      statusChanges: Array<{
        __typename?: 'StatusChange',
        id: number,
        actualTime?: number | null,
        actualTimeOriginal?: number | null,
        actualTimeOverride?: number | null,
        estimateTime?: number | null,
        comment?: string | null,
        skipperComment?: string | null,
        timestamp?: number | null,
        appliedBy?: string | null,
        deletable: boolean,
        communicatedToCustomer?: number | null,
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }>,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null
        },
        supplier?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        origin?: {
          __typename?: 'StatusChange',
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }
        } | null
      }>,
      invoiceGroupType?: {
        __typename?: 'InvoiceGroupType',
        id: number,
        name: string
      } | null,
      charter?: {
        __typename?: 'PurchaseCharter',
        blDate?: number | null,
        id: number,
        charterNumber: string,
        type: Types.CharterType,
        customerReference?: string | null,
        subtype: Types.CharterSubtype,
        voyages?: Array<{
          __typename?: 'Voyage',
          ship: {
            __typename?: 'Ship',
            id: number,
            name: string
          },
          cargoCharters?: Array<{
            __typename?: 'SalesCharter',
            id: number,
            charterNumber: string,
            type: Types.CharterType,
            subtype: Types.CharterSubtype,
            customerReference?: string | null,
            dossierNumber?: string | null
          } | null> | null
        }> | null,
        contract?: {
          __typename?: 'Contract',
          currency?: {
            __typename?: 'Currency',
            symbol?: string | null,
            isoCode?: string | null
          } | null
        } | null
      } | {
        __typename?: 'SalesCharter',
        blDate?: number | null,
        dossierNumber?: string | null,
        customerReference?: string | null,
        id: number,
        charterNumber: string,
        type: Types.CharterType,
        subtype: Types.CharterSubtype,
        status: {
          __typename?: 'SalesCharterStatusType',
          name: Types.SalesCharterStatus,
          color: string,
          languageKeyPrefix: string
        },
        purchaseCharter?: {
          __typename?: 'PurchaseCharter',
          charterNumber: string,
          type: Types.CharterType,
          subtype: Types.CharterSubtype,
          voyages?: Array<{
            __typename?: 'Voyage',
            ship: {
              __typename?: 'Ship',
              id: number,
              name: string
            }
          }> | null
        } | null,
        contract?: {
          __typename?: 'Contract',
          currency?: {
            __typename?: 'Currency',
            symbol?: string | null,
            isoCode?: string | null
          } | null
        } | null
      } | null,
      invoiceLines: Array<{
        __typename?: 'InvoiceLine',
        id: number,
        approved?: boolean | null,
        invoice?: {
          __typename?: 'Invoice',
          id: number,
          invoiceNumber?: string | null
        } | null,
        creditor?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        debtor?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null
      }>
    }>
  }
};

export type InvoiceableRelationsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type InvoiceableRelationsQuery = {
  __typename?: 'Query',
  searchInvoicelines?: {
    __typename?: 'InvoicelinePage',
    content?: Array<{
      __typename?: 'InvoiceLine',
      creditor?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      debtor?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null
    }> | null
  } | null
};

export type SearchInvoiceLinesForInvoicingQueryVariables = Types.Exact<{
  search?: Types.InputMaybe<Types.InvoicelineSearch>;
  pagination: Types.Pagination;
}>;


export type SearchInvoiceLinesForInvoicingQuery = {
  __typename?: 'Query',
  searchInvoicelines?: {
    __typename?: 'InvoicelinePage',
    totalElements?: number | null,
    content?: Array<{
      __typename?: 'InvoiceLine',
      id: number,
      description?: string | null,
      weekNumber?: number | null,
      quantity?: number | null,
      unit?: string | null,
      totalPriceExcVAT?: number | null,
      totalPriceIncVAT?: number | null,
      calculationSummary?: string | null,
      summary?: string | null,
      unexpected?: boolean | null,
      invoiceReference?: string | null,
      approved?: boolean | null,
      creditor?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      debtor?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      price?: {
        __typename?: 'Price',
        value?: number | null,
        currency?: {
          __typename?: 'Currency',
          isoCode?: string | null,
          symbol?: string | null
        } | null
      } | null,
      vatCode?: {
        __typename?: 'VATCode',
        id: number,
        label?: string | null
      } | null,
      agreement?: {
        __typename?: 'AddressCommissionAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'BlockFreightAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'BunkerAdjustmentAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'CleaningAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'CommissionAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'DailyAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'DangerousGoodAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'DeadfreightAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'DemurrageAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'DemurrageCalculationAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'FeetAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'FreightAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'GasolineAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'GasolinePriceAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'HoseRentalAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'HourlyAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'LumpsumAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'MultiCargoAdjustmentAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'MultiOrderAdjustmentAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'NitrogenPurgingAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'OogAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'PJKAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'PostCalculationAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'ReeferAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'RentAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'ReturnFreightDiscountAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'ShipAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'SupplementaryHeatingAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'TeuAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'TextAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'WaterLevelAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'WaterwayAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'WeightAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | {
        __typename?: 'WeightRangeAgreement',
        id: number,
        type: Types.AgreementTypeEnum,
        description?: string | null,
        calculationMethod?: {
          __typename?: 'CargoQuantityCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'CoveredByFreightPriceCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'DemurrageCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'GasoilConsumptionCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'LumpsumCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ManualCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'PercentageOnAgreementsCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'QuantityUnitCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'ReferenceRateCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'StaffelCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TieredCalculationMethod',
          summary?: string | null
        } | {
          __typename?: 'TimeUnitCalculationMethod',
          summary?: string | null
        } | null
      } | null,
      costType?: {
        __typename?: 'CostType',
        id: number,
        title_en?: string | null,
        title_nl?: string | null,
        title_de?: string | null
      } | null,
      charter?: {
        __typename?: 'PurchaseCharter',
        id: number,
        charterNumber: string,
        type: Types.CharterType,
        subtype: Types.CharterSubtype,
        contract?: {
          __typename?: 'Contract',
          id: number,
          contractNumber?: string | null
        } | null
      } | {
        __typename?: 'SalesCharter',
        blDate?: number | null,
        id: number,
        charterNumber: string,
        type: Types.CharterType,
        subtype: Types.CharterSubtype,
        status: {
          __typename?: 'SalesCharterStatusType',
          name: Types.SalesCharterStatus,
          color: string,
          languageKeyPrefix: string
        },
        contract?: {
          __typename?: 'Contract',
          id: number,
          contractNumber?: string | null
        } | null
      } | null,
      declaration?: {
        __typename?: 'PurchaseDeclaration',
        id: number,
        charter?: {
          __typename?: 'PurchaseCharter',
          id: number,
          charterNumber: string,
          type: Types.CharterType
        } | {
          __typename?: 'SalesCharter',
          blDate?: number | null,
          id: number,
          charterNumber: string,
          type: Types.CharterType
        } | null,
        lastStatusChange?: {
          __typename?: 'StatusChange',
          id: number,
          actualTime?: number | null,
          actualTimeOriginal?: number | null,
          actualTimeOverride?: number | null,
          estimateTime?: number | null,
          comment?: string | null,
          skipperComment?: string | null,
          timestamp?: number | null,
          appliedBy?: string | null,
          deletable: boolean,
          communicatedToCustomer?: number | null,
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }>,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null
          },
          supplier?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          origin?: {
            __typename?: 'StatusChange',
            status: {
              __typename?: 'Status',
              id: number,
              description: string,
              type: Types.StatusType,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }
          } | null
        } | null,
        statusChanges: Array<{
          __typename?: 'StatusChange',
          id: number,
          actualTime?: number | null,
          actualTimeOriginal?: number | null,
          actualTimeOverride?: number | null,
          estimateTime?: number | null,
          comment?: string | null,
          skipperComment?: string | null,
          timestamp?: number | null,
          appliedBy?: string | null,
          deletable: boolean,
          communicatedToCustomer?: number | null,
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }>,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null
          },
          supplier?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          origin?: {
            __typename?: 'StatusChange',
            status: {
              __typename?: 'Status',
              id: number,
              description: string,
              type: Types.StatusType,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }
          } | null
        }>
      } | {
        __typename?: 'SalesDeclaration',
        id: number,
        charter?: {
          __typename?: 'PurchaseCharter',
          id: number,
          charterNumber: string,
          type: Types.CharterType
        } | {
          __typename?: 'SalesCharter',
          blDate?: number | null,
          id: number,
          charterNumber: string,
          type: Types.CharterType
        } | null,
        lastStatusChange?: {
          __typename?: 'StatusChange',
          id: number,
          actualTime?: number | null,
          actualTimeOriginal?: number | null,
          actualTimeOverride?: number | null,
          estimateTime?: number | null,
          comment?: string | null,
          skipperComment?: string | null,
          timestamp?: number | null,
          appliedBy?: string | null,
          deletable: boolean,
          communicatedToCustomer?: number | null,
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }>,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null
          },
          supplier?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          origin?: {
            __typename?: 'StatusChange',
            status: {
              __typename?: 'Status',
              id: number,
              description: string,
              type: Types.StatusType,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }
          } | null
        } | null,
        statusChanges: Array<{
          __typename?: 'StatusChange',
          id: number,
          actualTime?: number | null,
          actualTimeOriginal?: number | null,
          actualTimeOverride?: number | null,
          estimateTime?: number | null,
          comment?: string | null,
          skipperComment?: string | null,
          timestamp?: number | null,
          appliedBy?: string | null,
          deletable: boolean,
          communicatedToCustomer?: number | null,
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }>,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null
          },
          supplier?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          origin?: {
            __typename?: 'StatusChange',
            status: {
              __typename?: 'Status',
              id: number,
              description: string,
              type: Types.StatusType,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }
          } | null
        }>
      } | null,
      ship?: {
        __typename?: 'Ship',
        id: number,
        name: string
      } | null
    }> | null
  } | null
};


export const SearchInvoicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchInvoices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InvoiceSearch"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalElements"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"invoice"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"invoice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Invoice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"yourReference"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isoCode"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentTerm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"days"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusChangeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StatusChange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualTime"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOriginal"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOverride"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTime"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"skipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"appliedBy"}},{"kind":"Field","name":{"kind":"Name","value":"deletable"}},{"kind":"Field","name":{"kind":"Name","value":"communicatedToCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ruleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ifFitsStatusFlow"}},{"kind":"Field","name":{"kind":"Name","value":"ifNotAppliedBefore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInSailingReport"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInWeightVolume"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"requireActualTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequirement"}},{"kind":"Field","name":{"kind":"Name","value":"shouldLoadOnTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loadedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"allowComment"}},{"kind":"Field","name":{"kind":"Name","value":"allowSkipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateJDE"}},{"kind":"Field","name":{"kind":"Name","value":"isInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"callVisibleByLocationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isRejectStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"notifySkippers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipManagers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipOwners"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOperators"}},{"kind":"Field","name":{"kind":"Name","value":"notifyCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyTerminals"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomerNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSkipperNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeInNominationExport"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"showConfirmMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiringStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isActionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireTanks"}}]}}]} as unknown as DocumentNode<SearchInvoicesQuery, SearchInvoicesQueryVariables>;
export const GetInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"invoice"}},{"kind":"Field","name":{"kind":"Name","value":"totalExcVAT"}},{"kind":"Field","name":{"kind":"Name","value":"totalVAT"}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvoiceLineTableRow"}},{"kind":"Field","name":{"kind":"Name","value":"declaration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"closedOn"}},{"kind":"Field","name":{"kind":"Name","value":"financiallyReadiedOn"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceGroupType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"invoice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Invoice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"yourReference"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isoCode"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentTerm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalReference"}},{"kind":"Field","name":{"kind":"Name","value":"days"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusChangeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StatusChange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualTime"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOriginal"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOverride"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTime"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"skipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"appliedBy"}},{"kind":"Field","name":{"kind":"Name","value":"deletable"}},{"kind":"Field","name":{"kind":"Name","value":"communicatedToCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ruleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ifFitsStatusFlow"}},{"kind":"Field","name":{"kind":"Name","value":"ifNotAppliedBefore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInSailingReport"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInWeightVolume"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"requireActualTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequirement"}},{"kind":"Field","name":{"kind":"Name","value":"shouldLoadOnTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loadedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"allowComment"}},{"kind":"Field","name":{"kind":"Name","value":"allowSkipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateJDE"}},{"kind":"Field","name":{"kind":"Name","value":"isInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"callVisibleByLocationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isRejectStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"notifySkippers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipManagers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipOwners"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOperators"}},{"kind":"Field","name":{"kind":"Name","value":"notifyCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyTerminals"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomerNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSkipperNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeInNominationExport"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"showConfirmMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiringStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isActionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireTanks"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvoiceLineTableRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvoiceLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"approved"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceExcVAT"}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceIncVAT"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceReference"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"unexpected"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"calculationSummary"}},{"kind":"Field","name":{"kind":"Name","value":"costType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title_en"}},{"kind":"Field","name":{"kind":"Name","value":"title_de"}},{"kind":"Field","name":{"kind":"Name","value":"title_nl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isoCode"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agreement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"calculationMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vatCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"declaration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactCharter"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SalesCharter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"languageKeyPrefix"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompactRelation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Relation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompactCharter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Charter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}}]}}]} as unknown as DocumentNode<GetInvoiceQuery, GetInvoiceQueryVariables>;
export const SearchDeclarationsForInvoicingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchDeclarationsForInvoicing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DeclarationSearch"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchDeclarations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalElements"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"declarationRowFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusChangeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StatusChange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualTime"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOriginal"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOverride"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTime"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"skipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"appliedBy"}},{"kind":"Field","name":{"kind":"Name","value":"deletable"}},{"kind":"Field","name":{"kind":"Name","value":"communicatedToCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ruleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ifFitsStatusFlow"}},{"kind":"Field","name":{"kind":"Name","value":"ifNotAppliedBefore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInSailingReport"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInWeightVolume"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"requireActualTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequirement"}},{"kind":"Field","name":{"kind":"Name","value":"shouldLoadOnTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loadedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"allowComment"}},{"kind":"Field","name":{"kind":"Name","value":"allowSkipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateJDE"}},{"kind":"Field","name":{"kind":"Name","value":"isInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"callVisibleByLocationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isRejectStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"notifySkippers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipManagers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipOwners"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOperators"}},{"kind":"Field","name":{"kind":"Name","value":"notifyCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyTerminals"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomerNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSkipperNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeInNominationExport"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"showConfirmMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiringStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isActionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireTanks"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"declarationRowFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Declaration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"closedOn"}},{"kind":"Field","name":{"kind":"Name","value":"financiallyReadiedOn"}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceExcVAT"}},{"kind":"Field","name":{"kind":"Name","value":"window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceGroupType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"customerReference"}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SalesCharter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blDate"}},{"kind":"Field","name":{"kind":"Name","value":"dossierNumber"}},{"kind":"Field","name":{"kind":"Name","value":"customerReference"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"languageKeyPrefix"}}]}},{"kind":"Field","name":{"kind":"Name","value":"purchaseCharter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"voyages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PurchaseCharter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blDate"}},{"kind":"Field","name":{"kind":"Name","value":"voyages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargoCharters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"Field","name":{"kind":"Name","value":"customerReference"}},{"kind":"Field","name":{"kind":"Name","value":"dossierNumber"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"symbol"}},{"kind":"Field","name":{"kind":"Name","value":"isoCode"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceLines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"approved"}},{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<SearchDeclarationsForInvoicingQuery, SearchDeclarationsForInvoicingQueryVariables>;
export const InvoiceableRelationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InvoiceableRelations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchInvoicelines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"approved"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"page"},"value":{"kind":"IntValue","value":"0"}},{"kind":"ObjectField","name":{"kind":"Name","value":"size"},"value":{"kind":"IntValue","value":"10000"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<InvoiceableRelationsQuery, InvoiceableRelationsQueryVariables>;
export const SearchInvoiceLinesForInvoicingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchInvoiceLinesForInvoicing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InvoicelineSearch"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchInvoicelines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalElements"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weekNumber"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isoCode"}},{"kind":"Field","name":{"kind":"Name","value":"symbol"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"vatCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agreement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"calculationMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceExcVAT"}},{"kind":"Field","name":{"kind":"Name","value":"totalPriceIncVAT"}},{"kind":"Field","name":{"kind":"Name","value":"calculationSummary"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"costType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title_en"}},{"kind":"Field","name":{"kind":"Name","value":"title_nl"}},{"kind":"Field","name":{"kind":"Name","value":"title_de"}}]}},{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"subtype"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SalesCharter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"languageKeyPrefix"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"declaration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SalesCharter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unexpected"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceReference"}},{"kind":"Field","name":{"kind":"Name","value":"approved"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusChangeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StatusChange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualTime"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOriginal"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOverride"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTime"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"skipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"appliedBy"}},{"kind":"Field","name":{"kind":"Name","value":"deletable"}},{"kind":"Field","name":{"kind":"Name","value":"communicatedToCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ruleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ifFitsStatusFlow"}},{"kind":"Field","name":{"kind":"Name","value":"ifNotAppliedBefore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInSailingReport"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInWeightVolume"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"requireActualTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequirement"}},{"kind":"Field","name":{"kind":"Name","value":"shouldLoadOnTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loadedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"allowComment"}},{"kind":"Field","name":{"kind":"Name","value":"allowSkipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateJDE"}},{"kind":"Field","name":{"kind":"Name","value":"isInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"callVisibleByLocationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isRejectStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"notifySkippers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipManagers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipOwners"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOperators"}},{"kind":"Field","name":{"kind":"Name","value":"notifyCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyTerminals"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomerNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSkipperNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeInNominationExport"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"showConfirmMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiringStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isActionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireTanks"}}]}}]} as unknown as DocumentNode<SearchInvoiceLinesForInvoicingQuery, SearchInvoiceLinesForInvoicingQueryVariables>;